import React from 'react';

export interface JobListing {
  id: string;
  companyName: string;
  companyLogo?: string | null;
  jobTitle: string;
  location: string;
  workMode: 'Remote' | 'Hybrid' | 'On-site';
  employmentType: 'Full-time' | 'Part-time' | 'Contract';
  seniority?: string;
  description?: string;
  salary?: string | null;
  applyUrl?: string | null;
  postedDate?: string | null;
  requirements?: string[];
  responsibilities?: string[];
  benefits?: string[];
  companyWebsite?: string | null;
}

interface JobCardProps {
  job: JobListing;
  onClick?: () => void;
}

export const JobCard: React.FC<JobCardProps> = ({ job, onClick }) => {
  return (
    <div
      className="card-premium p-4 md:p-6 w-full cursor-pointer group flex flex-col h-full hover:border-blue-200 transition-all duration-300"
      onClick={onClick}
    >
      {/* Company Section */}
      <div className="flex items-center gap-3 md:gap-4 mb-3 md:mb-5">
        {job.companyLogo ? (
          <img
            src={job.companyLogo}
            alt={job.companyName}
            className="w-11 h-11 md:w-14 md:h-14 object-contain rounded-xl border border-slate-100 bg-white shadow-sm group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-11 h-11 md:w-14 md:h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-200 group-hover:scale-105 transition-transform duration-300">
            <span className="text-white font-bold text-lg md:text-xl">
              {job.companyName.charAt(0)}
            </span>
          </div>
        )}
        <div className="min-w-0 flex-1">
          <h3 className="font-semibold text-slate-900 text-base md:text-lg leading-tight group-hover:text-blue-600 transition-colors truncate">
            {job.companyName}
          </h3>
          <p className="text-xs md:text-sm text-slate-500 mt-0.5 truncate">{job.location}</p>
        </div>
      </div>

      {/* Job Title */}
      <h4 className="text-base md:text-xl font-bold text-slate-900 mb-3 md:mb-4 line-clamp-2 flex-1">
        {job.jobTitle}
      </h4>

      {/* Tags/Pills */}
      <div className="flex flex-wrap gap-1.5 md:gap-2 mt-auto">
        <span className="px-2 md:px-3 py-0.5 md:py-1 bg-blue-50 text-blue-700 text-[10px] md:text-xs font-semibold rounded-lg border border-blue-100">
          {job.seniority || 'Mid-level'}
        </span>
        <span className="px-2 md:px-3 py-0.5 md:py-1 bg-slate-50 text-slate-600 text-[10px] md:text-xs font-semibold rounded-lg border border-slate-100">
          {job.workMode}
        </span>
        <span className="px-2 md:px-3 py-0.5 md:py-1 bg-slate-50 text-slate-600 text-[10px] md:text-xs font-semibold rounded-lg border border-slate-100">
          {job.employmentType}
        </span>
      </div>
    </div>
  );
};
